import marked from 'marked';

export const markdownCompilerService = {
  compile: marked,
};
